import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllProducts } from "../../redux/Slices/ProductSlice";

const UseManageAllProducts = () => {
  const limit = 4
  const dispatch = useDispatch();
  const [allProductsResponse, setAllProductsResponse] = useState([])
  const [pagesCount, setPagesCount] = useState(0)
  const [loading, setLoading] = useState(true)
  const [searchLoading, setSearchLoading] = useState(true)
  const [searchValue, setSearchValue] = useState("")
  const [loadingPagination, setLoadingPagination] = useState(true)
  const { allProducts } = useSelector((state) => state.ProductReducer);


  // dispatch get of all products
  const handleGetAllProducts = async () => {
    setLoading(true)
    await dispatch(getAllProducts(`limit=${limit}`));
    setLoading(false)
  }

  // run get of all products 
  useEffect(() => {
    handleGetAllProducts();
  }, []);


  // Dispatch getAllProductsWithPage action when onPress is called
  const onPress = async (page) => {
    setLoadingPagination(true)
    await dispatch(getAllProducts(`limit=${limit}&page=${page}`));
    setLoadingPagination(false)
  };

  // handle request response
  useEffect(() => {
    if (loading === false || loadingPagination === false) {
      if (allProducts && allProducts.data) {
        setAllProductsResponse(allProducts.data.data)
        setPagesCount(allProducts.data.paginationResult.numberOfPages)
      }
    }
  }, [loading, loadingPagination])

  // handle on change the search input value
  const handleChangeSearchValue = (e) => {
    setSearchValue(e.target.value)
  }

  // dispatch the search product function
  const handleSearchProductValue = async () => {
    setSearchLoading(true)
    await dispatch(getAllProducts(`limit=${limit}&title=${searchValue}`))
    setSearchLoading(false)
  }

  // handle search request response
  useEffect(() => {
    if (searchLoading === false) {
      if (allProducts && allProducts.data) {
        setAllProductsResponse(allProducts.data.data)
      }
    }
  }, [searchLoading])

  // run the functions based on the search value
  useEffect(() => {
    if (searchValue === "") {
      handleGetAllProducts()
    } else {
      handleSearchProductValue()
    }
  }, [searchValue])

  
  return [allProductsResponse, pagesCount, onPress, loading, searchValue, handleChangeSearchValue];
};
export default UseManageAllProducts;
